import { useState } from "react";
import { copyToClipboard } from "../utils";

const TileBOLs = ({ data = {}, t }) => {
  const [copied, setCopied] = useState(false);
  const str = (v) => (v != null ? String(v).trim() : "");

  const carrierCode = str(data.carrier_code);
  const vesselName = str(data.vessel_name);
  const masterBol = str(data.master_bol_number);
  const voyageNumber = str(data.voyage_number);

  const fromPort = str(data.foreign_port_of_lading_name);
  const toPort = str(data.port_of_unlading_name);
  const route =
    fromPort && toPort ? `${fromPort} → ${toPort}` : fromPort || toPort;

  const qty = data.manifest_quantity;
  const unit = str(data.manifest_unit);
  const qtyLabel = qty != null ? `${qty} ${unit}`.trim() : "";

  const weightKg = data.weight_in_kg ?? data.weight;
  const weightLabel =
    weightKg != null
      ? `${weightKg.toLocaleString()} ${str(data.weight_unit) || "KG"}`
      : "";

  if (!carrierCode && !vesselName && !masterBol) return null;

  const handleCopy = async (e) => {
    e.stopPropagation();
    await copyToClipboard(masterBol);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* Top row: carrier badge + vessel name + pills */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* Carrier code badge — mirrors the coin symbol chip */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: t.labelBg,
              border: `1px solid ${t.labelBorder}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.04em",
              color: t.textSecondary,
              fontFamily: "monospace",
            }}
          >
            {(carrierCode || "BOL").slice(0, 4).toUpperCase()}
          </div>

          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            {/* Vessel name — mirrors coin name */}
            {vesselName && (
              <span
                style={{ fontSize: 15, fontWeight: 600, color: t.textPrimary }}
              >
                {vesselName}
              </span>
            )}

            {/* Voyage number — mirrors title badge */}
            {voyageNumber && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.badgeBg,
                  border: `1px solid ${t.badgeBorder}`,
                  color: t.badgeText,
                }}
              >
                VOY {voyageNumber}
              </span>
            )}

            {/* Quantity — mirrors assetType badge */}
            {qtyLabel && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {qtyLabel}
              </span>
            )}

            {/* Weight — mirrors standard badge */}
            {weightLabel && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {weightLabel}
              </span>
            )}
          </div>
        </div>

        {/* Route line — sits between top row and copy row when both exist */}
        {route && (
          <p
            style={{
              fontSize: 11,
              color: t.textMuted,
              margin: 0,
              fontFamily: "monospace",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={route}
          >
            {route}
          </p>
        )}

        {/* BOL number copy row — mirrors address copy row */}
        {masterBol && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            <button
              onClick={handleCopy}
              type="button"
              aria-label="Copy BOL number"
              style={{
                flexShrink: 0,
                padding: 6,
                borderRadius: 8,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                color: copied ? t.successText : t.textMuted,
                transition: "color 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = t.pillHoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {copied ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              ) : (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" />
                  <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                </svg>
              )}
            </button>
            <p
              style={{
                fontSize: 11,
                color: t.textMuted,
                margin: 0,
                fontFamily: "monospace",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
              title={masterBol}
            >
              {masterBol}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TileBOLs;
